import React, { useContext } from 'react'
import { ModalContext } from '../../../../../../../contexts'
import { Text } from '../../../../../../../components'
import { MODAL_FIELD_INFO } from '../../../../../../../constants/display'

export const InfoModalHeader = () => {
  // TODO update types once modal files are tsx
  const { fieldInfo } = useContext(ModalContext) as any

  const copy = () => {
    switch (fieldInfo) {
      case MODAL_FIELD_INFO.CURRENT_MONTHLY_HOME_COSTS:
        return 'Current monthly home costs'
      case MODAL_FIELD_INFO.RENTER_CURRENT_MONTHLY_RENT_COSTS:
        return 'Current monthly rent costs'
      case MODAL_FIELD_INFO.FUTURE_MONTHLY_HOME_COSTS:
      case MODAL_FIELD_INFO.RENTER_FUTURE_MONTHLY_HOME_COSTS:
        return 'Future monthly home costs'
      case MODAL_FIELD_INFO.DOWN_PAYMENT:
        return 'Down payment'
      case MODAL_FIELD_INFO.YEARS_IN_HOME:
        return 'Years in home'
      case MODAL_FIELD_INFO.RENTABLE_NIGHTS:
        return 'Rentable nights'
      default:
        return ''
    }
  }
  return (
    <Text color='white' weight='semibold'>
      {copy()}
    </Text>
  )
}
